<template>
	<span aria-hidden="true" :class="['c-icon', size]">
		<svg>
			<use :xlink:href="path"></use>
		</svg>
	</span>
</template>

<script>
export default {
    name: 'VueIcon',
    props: {
        name: {
            type: String,
            default: ''
		},
		size: {
			type: String,
			default: 'c-icon--28px'
		}
	},
	computed: {
		path() {
			return '#icon-' + this.name; 
		}
	},
}
</script>
